import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRouteInfo } from '../../../services/routing/useRouteInfo';
import { useFeatureContext } from '../../feature/featureContext';
import { LoadText } from '../../shared/load/loadText';
import { ReactComponent as BranchesIcon } from './../../../assets/icons/branch.svg';
import { ReactComponent as CampaignIcon } from './../../../assets/icons/campaign.svg';
import { ReactComponent as CommunicationsIcon } from './../../../assets/icons/communications.svg';
import { ReactComponent as DashboardIcon } from './../../../assets/icons/dashboard.svg';
import { ReactComponent as LocationsIcon } from './../../../assets/icons/locations.svg';
import { ReactComponent as SlashIcon } from './../../../assets/icons/slash.svg';
import { ReactComponent as SystemIcon } from './../../../assets/icons/systems.svg';
import { ReactComponent as UsersIcon } from './../../../assets/icons/users.svg';
import { ReactComponent as ZipCodesIcon } from './../../../assets/icons/zipcode.svg';
import { ReactComponent as AfterHourReferralRuleIcon } from './../../../assets/icons/after-hours-referral-rules.svg';

import styles from './pathNav.module.css';

const urlMap = {
    '/home': {
        icon: <DashboardIcon/>,
        label: 'Home',
        navigable: true
    },
    '/home/locations': {
        icon: <LocationsIcon/>,
        label: 'Locations',
        navigable: false
    },
    '/home/locations/branches': {
        icon: <BranchesIcon/>,
        label: 'Branches',
        navigable: true
    },
    '/home/locations/zipcodes': {
        icon: <ZipCodesIcon/>,
        label: 'Zip Codes',
        navigable: true
    },
    '/home/communications': {
        icon: <CommunicationsIcon/>,
        label: 'Communications',
        navigable: false
    },
    '/home/communications/campaigns': {
        icon: <CampaignIcon/>,
        label: 'Campaigns',
        navigable: true
    },
    '/home/systemAccess': {
        icon: <SystemIcon/>,
        label: 'Systems Access',
        navigable: true
    },
    '/home/afterHourReferralRules': {
        icon: <AfterHourReferralRuleIcon/>,
        label: 'After Hour Referral Rules',
        navigable: true
    },
    '/home/users': {
        icon: <UsersIcon/>,
        label: 'Users',
        navigable: true
    }
}

export const PathNav = () => {

    const navigate = useNavigate();

    const { featureContext } = useFeatureContext();

    const location = useLocation();
    const routeInfo = useRouteInfo();

    const getPathSeg = (path) => (path?.endsWith(featureContext?.id)) ?
        {
            label: featureContext.loading ? 
                <LoadText dark={false} width='75px' />
                : featureContext?.name ?? featureContext?.id,
            navigable: featureContext?.navigable ?? true
        }
    :
        urlMap[path];

    const path = () => ('home' + location.pathname).replace(/\/$/g, '').split('/');

    return <div className={styles.PathNav}>
        { (() => {
            let p = '';
            return (routeInfo.showPathNav ?? false) ?
            path().map((s, i) => {
                p += '/' + s;
                const intractable = (getPathSeg(p)?.navigable && path().length - 1 > i) ?? false;

                return <React.Fragment key={s}>
                    { (i != 0) ?
                        <div className={styles.Slash}><SlashIcon /></div>
                    : '' }
                    <div
                        className={styles.Item + (intractable ? ' ' + styles.Intractable : '')}
                        onClick={() => {
                            if (intractable) navigate(path().splice(1, i).join('/'))
                        }}
                    >
                    <div className={'icon bold text-color ' + styles.Icon}>
                            {getPathSeg(p)?.icon ?? ''}
                        </div>
                        <div className={styles.Label}>
                            {getPathSeg(p)?.label ?? s}
                        </div>
                    </div>
                </React.Fragment>
            })
            : <></>
        })() }
    </div>
}